<template>
  <el-container>
    <el-header style="padding: 0; min-height: 30px;">
      <el-page-header @back="goBack" :content="pageTitle">
      </el-page-header>
    </el-header>
    
    <el-main>
      <el-steps :active="step" simple class="t_top">
        <el-step title="第一步：课程基本信息" icon="el-icon-edit"></el-step>
        <el-step title="第二步：课程简介" icon="el-icon-upload"></el-step>
        <el-step title="第三步：课程内容" icon="el-icon-picture"></el-step>
      </el-steps>
      <template v-if="step == 1">
        <step1 :form="form" :rules="rules"  @changeStep="changeStep"></step1>
      </template>
      <template v-if="step == 2">
        <step2 :form="form" @changeStep="changeStep"></step2>
      </template>
      <template v-if="step == 3">
        <step3 :form="form" :rules="rules"></step3>
      </template>
    </el-main>
  </el-container>
</template>

<script>
  import step1 from "./step1"
  import step2 from "./step2"
  import step3 from "./step3"
  import validate from '@/api/validate.js';
  
  export default {
    name: 'addCommodity1',
    components: {step1,step2,step3},
    data() {
      var validPeriod = (rule, value, callback) => {
        const reg = /^\d{1,4}$/;
        console.log(value);
        if(this.form.validityType == 1) {
          callback();
        } else if (value === '' || value < 0) {
          callback(new Error('有效期不能为0,负数或者空'));
        } else if(!reg.test(value)) {
          callback(new Error('只允许输入1-9999的正整数'));
        } else {
          callback();
        }
      };
      return {
        pageTitle:'添加商品',
        step: 3,
        form: {
          commodityId: '',
          courseName: '',
          ccId: '',
          orgCcId: '',
          ccPId: '',
          price: '',
          validity: '',
          validityType: 1,
          introduce: '',
          modelType: 1,
          preferential: '',
          persionNum: '',
          classTime: '',
          openClassType: 1,
          openClassTime: new Date(),
          lessonType: 1,
          commodityLecturerList: [],
          lecturers: [],
          lecturer: [],
          auditionVideoPath: '',
          auditionVideoPathView: '',
          picturePath: '',
          picturePathView: '',
          courseIntroduce: '',
          courseId: '',
          courseView: '',
          orgCode: '',
          contactInfo: '',
          autoMessage: [],
          standard: '',
          sort: '',
          orgSort: '',
          isView: 1,
          isPacking: 0,
          courseType: 0
        },
        rules: {
          courseName: [
            {required: true, message: '请输入课程名称', trigger: 'blur'},
            {max: 50, message: '长度不得超过50个字符', trigger: 'blur'}
          ],
          courseEnglishName: [
            {required: true, message: '请输入课程名称', trigger: 'blur'},
            {max: 50, message: '长度不得超过50个字符', trigger: 'blur'}
          ],
          ccId:[
            {required: true, message: '请选择主营类目', trigger: 'blur'}
          ],
          blur: [
            {required: true, message: '请选择分类', trigger: 'blur'}
          ],
          orgCcId: [
            {required: true, message: '请选择分类', trigger: 'blur'}
          ],
          introduce: [
            {required: true, message: '请输入特色介绍', trigger: 'blur'},
            {max: 30, message: '长度不得超过30个字符', trigger: 'blur'}
          ],
          englishIntroduce: [
            {required: true, message: '请输入特色介绍', trigger: 'blur'},
            {max: 100, message: '长度不得超过100个字符', trigger: 'blur'}
          ],
          price: [
            {required: true, message: '请输入价格', trigger: 'blur'},
            {validator: validate.validatePrice, trigger: 'blur'}
          ],
          preferential: [
            {required: true, message: '请输入优惠价格', trigger: 'blur'},
            {validator: validate.validatePrice, trigger: 'blur'}
          ],
          standard: [
            {required: true, message: '请输入课时标准', trigger: 'blur'},
            {validator: validate.validatePrice, trigger: 'blur'}
          ],
          persionNum: [
            {required: true, message: '请输入人数', trigger: 'blur'},
            {validator: validate.validateNumber, trigger: 'blur'}
          ],
          classTime: [
            {required: true, message: '请输入课时', trigger: 'blur'},
            {validator: validate.validateClassTime, trigger: 'blur'}
          ],
          validity: [
            {validator: validPeriod, trigger: 'change'}
          ],
          openClassTime: [
            {required: true, message: '请选择开班日期', trigger: 'blur'}
          ],
          lessonType: [
            {required: true, message: '请选择授课类型', trigger: 'blur'}
          ],
          orgCode: [
            {required: true, message: '请选择所属机构', trigger: 'blur'}
          ],
          picturePath: [
            {required: true, message: '请上传课程封面', trigger: 'change'}
          ],
          isView: [
            {required: true, message: '请选择是否显示', trigger: 'blur'}
          ],
          isPacking: [
            {required: true, message: '请选择是否打包', trigger: 'blur'}
          ],
          courseId: [
            {required: true, message: '请选择关联课程', trigger: 'blur'}
          ],
          contactInfo: [
            {validator: validate.validateQQ, trigger: 'blur'}
          ],
          sort: [
            {validator: validate.validateSort, trigger: 'blur'}
          ],
          courseType:[
            {required: true, message: '请选择课程分类', trigger: 'blur'}
          ]
        },
      }
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      
      changeStep(type, val) {
        if(type == "next") {
          this.step = this.step + 1;
        }
        if(type == "prev") {
          this.step = this.step - 1;
        }
      }
    },
  };
</script>


<style>
  .avatar-uploader {
    width: 500px;
  }
  
  .t_top {
    margin-bottom: 10px;
  }
  
  .t_center {
    width: 60%;
    margin: 0 auto;
  }
  
  .t_center1 {
    width: 100%;
    margin: 0 auto;
  }
  
  .avatar-uploader {
    width: 95%;
  }
  
  .ql-editor {
    min-height: 300px;
  }
  
  .hide .el-upload--picture-card {
    display: none;
  }
  .ql-snow .ql-picker.ql-lineheight {
    width: 70px;
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-label::before {
    content: '行高';
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='initial']::before {
    content: '默认';
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='1']::before {
    content: '1';
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='1.5']::before {
    content: '1.5';
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='1.75']::before {
    content: '1.75';
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='2']::before {
    content: '2';
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='3']::before {
    content: '3';
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='4']::before {
    content: '4';
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='5']::before {
    content: '5';
  }
  .el-tag{
    cursor: pointer;
  }
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
  .el-table th {
    padding: 0;
  }
  .el-table .cell, .el-table th div, .el-table--border td:first-child .cell, .el-table--border th:first-child .cell {
    padding-left: 0;
  }
  .el-table .cell, .el-table th div {
    padding-right: 0;
  }
</style>
<style scoped>
  .input_ >>> .el-input-group{
    vertical-align: 0;
  }
</style>
